import { TWorkspace } from "types/user.types";
import { adminRoles, policyAdminRoles, securityAdminRoles, superAdminRoles, UserRole } from "utils/role";

type Page = {
  second: string;
  third?: string[];
};
type Category = {
  key?: string;
  pages: Page[];
  isShow?: boolean;
};
type Pages = {
  meeting: Category[];
  visitors: Category[];
  analytics: Category[];
  setting: Category[];
};

//* INFO: 내 롤에 따른 페이지 접근 권한 리턴
export const userHasAccess = (roles: UserRole[], myRole: UserRole): boolean => roles.includes(myRole ?? "Staff");

export class PageAccessUtils {
  userHasAccess(roles: UserRole[], myRole: UserRole): boolean {
    return roles.includes(myRole ?? "Staff");
  }
  getMeetingPages(isComplainManager: boolean, myRole: UserRole): Category[] {
    const 공통 = {
      key: "공통",
      pages: [
        { second: "예약 현황" },
        { second: "나의 예약/참석" },
        { second: "나의 알림 설정" },
        { second: "회의실 예약 제한 요청" },
      ],
      isShow: true,
    };

    const 관리자: any = [];
    if (userHasAccess(policyAdminRoles, myRole)) {
      if (userHasAccess(superAdminRoles, myRole)) {
        관리자.push({
          second: "운영/예약 정책 관리",
          third: ["노쇼 정책 관리", "알림 정책 설정", "태블릿 정책 설정", "최소 참석 인원 관리", "예약 제한 요청 관리"],
        });
      } else
        관리자.push({
          second: "운영/예약 정책 관리",
          third: ["노쇼 정책 관리", "알림 정책 설정", "태블릿 정책 설정", "최소 참석 인원 관리"],
        });

      관리자.push({
        second: "회의실 관리",
        third: ["회의실 등록 및 설정", "회의실 기기 관리"],
      });
    }

    const 회의실_민원_관리 = [];
    if (userHasAccess(policyAdminRoles, myRole) || isComplainManager) {
      회의실_민원_관리.push("민원 내역 조회");

      if (userHasAccess(policyAdminRoles, myRole)) {
        회의실_민원_관리.push("민원 유형 설정", "민원 담당자 설정");
      }

      관리자.push({ second: "회의실 민원 관리", third: 회의실_민원_관리 });
    }

    return [
      공통,
      {
        key: "관리자",
        pages: 관리자,
        isShow: isComplainManager || userHasAccess(policyAdminRoles, myRole),
      },
    ];
  }
  getVisitorsPages(myRole: UserRole): Category[] {
    const pages: Page[] = [{ second: "나의 방문 관리" }];

    if (userHasAccess(policyAdminRoles, myRole)) {
      pages.push({
        second: "서비스 커스터마이징",
        third: ["사전 방문 관리", "방문 안내 메시지 관리", "체크인/체크아웃 정책 관리"],
      });
      pages.push({ second: "기기 관리" });
    }
    return [
      {
        pages: pages,
        isShow: true,
      },
    ];
  }
  getAnalyticsPages(workspaceInfo: TWorkspace, myRole: UserRole): Category[] {
    const pages = [];

    if (userHasAccess(securityAdminRoles, myRole)) {
      pages.push({
        second: "Mile Meeting",
        third: ["회의실 현황 대시보드", "회의실 이용 현황 데이터"],
      });

      if (workspaceInfo?.mileVisitorsUsage) {
        pages.push({
          second: "Mile Visitors",
          third: ["방문자 현황 대시보드", "방문자 관리 데이터"],
        });
      }
    }

    return [
      {
        pages: pages,
        isShow: true,
      },
    ];
  }
  getSettingPages(myRole: UserRole): Category[] {
    const commonPages = {
      key: "공통",
      pages: [{ second: "내 정보 관리" }, { second: "서비스 연동 관리" }],
      isShow: true,
    };

    const adminPages = [];

    if (userHasAccess(policyAdminRoles, myRole)) {
      adminPages.push({ second: "워크스페이스 관리" });
    }

    if (userHasAccess(adminRoles, myRole)) {
      adminPages.push({ second: "멤버 관리" });
    }

    if (userHasAccess(superAdminRoles, myRole)) {
      adminPages.push({ second: "서비스 플랜 관리" });
    }

    return [
      commonPages,
      {
        key: "관리자",
        pages: adminPages,
        isShow: userHasAccess(adminRoles, myRole),
      },
    ];
  }
  getPages(workspace: TWorkspace, isComplainManager: boolean, myRole: UserRole): Pages {
    return {
      meeting: this.getMeetingPages(isComplainManager, myRole),
      visitors: workspace.mileVisitorsUsage ? this.getVisitorsPages(myRole) : [],
      analytics: userHasAccess(securityAdminRoles, myRole) ? this.getAnalyticsPages(workspace, myRole) : [],
      setting: this.getSettingPages(myRole),
    };
  }
}
